const INPUT_OPTIONS = {
    brand_id: {
        fieldId: 2364367
    },
    ticket_form_id: {
        fieldId: 360000033656
    },
    FirstName: {
        fieldId: 80635907
    },
    LastName: {
        fieldId: 80635927
    },
    MobilePhone: {
        fieldId: 67323707
    },
    EmailAddress: {
        fieldId: 360000246736
    },
    self_exclusion_ticket: {
        fieldId: 360000212116
    }
};
module.exports = INPUT_OPTIONS;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/selfexclusion/selfexclusion-setup.js
 **/